import { Link } from "react-router-dom";

export function GlobalDisclaimer() {
  return (
    <div className="w-full px-4 pb-2 pt-3 bg-background">
      <p className="text-center text-[10px] leading-relaxed text-muted-foreground/70 font-body max-w-sm mx-auto">
        HairProEncyclopedia.ai may contain errors. Always verify formulas, chemical services, and techniques before performing professional services.
      </p>
      <p className="mt-1.5 text-center text-[10px] text-muted-foreground/70 font-body">
        <Link to="/terms" className="hover:text-foreground transition-colors underline underline-offset-2">
          Terms of Service
        </Link>
        <span className="mx-2 text-muted-foreground/70">·</span>
        <Link to="/about-hpe" className="hover:text-foreground transition-colors underline underline-offset-2">
          Guides
        </Link>
        <span className="mx-2 text-muted-foreground/70">·</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors underline underline-offset-2">
          Privacy Policy
        </Link>
      </p>
    </div>
  );
}
